<template>
  <svg class="minus-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 12H21" stroke="#1C6979" stroke-width="2" stroke-miterlimit="10"/>
  </svg>
</template>
